<main class="app-layout">
  <!-- Side Bar -->
  <app-sidebar class="app-sidebar"></app-sidebar>

  <!-- Header -->
  <app-header class="app-header"></app-header>

  <!-- Main Content-->
  <section class="app-content">
    <router-outlet></router-outlet>
  </section>
</main>
